import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactExport from 'react-export-excel-fixed-xlsx';

import Content from '../common/template/content';
import Row from '../common/layout/row';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import {
    setModoTela,
    initForm,
    setFiltro,
    getListaCooperativa,
    getListaEmpresa,
    getListaTurma,
    getListaRelatorioPresencaPorCooperativa,
    getListaRelatorioPresencaPorEmpresa,
    getListaRelatorioPresencaPorTurma,
    getListaRelatorioNuncaParticiparam,
    getListaRelatorioJustificativas
} from './relatorioActions';
import '../dashboard/dashboard.css';
import './relatorio.css';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ExcelFile.ExcelSheet;

const meses = [
    { id: '01', valor: 'Janeiro' },
    { id: '02', valor: 'Fevereiro' },
    { id: '03', valor: 'Março' },
    { id: '04', valor: 'Abril' },
    { id: '05', valor: 'Maio' },
    { id: '06', valor: 'Junho' },
    { id: '07', valor: 'Julho' },
    { id: '08', valor: 'Agosto' },
    { id: '09', valor: 'Setembro' },
    { id: '10', valor: 'Outubro' },
    { id: '11', valor: 'Novembro' },
    { id: '12', valor: 'Dezembro' }
];

class Relatorio extends Component {
    state = { linhaSelecionada: null };

    componentDidMount() {
        this.atualizar(this.props.filtro || {});
    }

    atualizar = (filtro = {}) => {
        this.props.setFiltro({ ...filtro });
        this.props.getListaCooperativa();
        this.props.getListaEmpresa();
        this.props.getListaTurma();
        this.props.getListaRelatorioPresencaPorCooperativa({ ...filtro });
        this.props.getListaRelatorioPresencaPorEmpresa({ ...filtro });
        this.props.getListaRelatorioPresencaPorTurma({ ...filtro });
        this.props.getListaRelatorioNuncaParticiparam({ ...filtro });
        this.props.getListaRelatorioJustificativas({ ...filtro });
    };

    formatarParticipacao = valor => FormatUtils.formatarValorTela(valor || 0, 2);

    renderParticipacao = valor => {
        const numero = Math.max(0, Math.min(Number(valor || 0), 100));
        return (
            <div className="report-participation">
                <div className="report-progress" aria-hidden="true">
                    <div className="report-progress-fill" style={{ width: `${numero}%` }} />
                </div>
                <strong>{this.formatarParticipacao(valor)}%</strong>
            </div>
        );
    };

    selecionarLinha = id => this.setState({ linhaSelecionada: id });

    criarResumoJustificativas = lista => {
        const agrupado = (lista || []).reduce((resultado, item) => {
            const chave = String(item.id_justificativa);
            const quantidade = Number(item.quantidade || 0);
            if (!resultado[chave]) {
                resultado[chave] = {
                    id_justificativa: item.id_justificativa,
                    nome_justificativa: item.nome_justificativa,
                    quantidade: 0
                };
            }
            resultado[chave].quantidade += quantidade;
            return resultado;
        }, {});
        const itens = Object.keys(agrupado).map(chave => agrupado[chave]);
        const total = itens.reduce((soma, item) => soma + item.quantidade, 0);

        return itens.map(item => ({
            ...item,
            participacao: total > 0 ? (item.quantidade * 100) / total : 0
        })).sort((a, b) => b.quantidade - a.quantidade);
    };

    criarJustificativasPorEmpresa = lista => {
        const totais = (lista || []).reduce((resultado, item) => {
            const chave = String(item.id_empresa);
            resultado[chave] = (resultado[chave] || 0) + Number(item.quantidade || 0);
            return resultado;
        }, {});

        return (lista || []).map(item => {
            const quantidade = Number(item.quantidade || 0);
            const totalEmpresa = totais[String(item.id_empresa)] || 0;
            return {
                ...item,
                quantidade,
                participacao: totalEmpresa > 0 ? (quantidade * 100) / totalEmpresa : 0
            };
        }).sort((a, b) => {
            const empresa = String(a.nome_empresa || '').localeCompare(String(b.nome_empresa || ''));
            return empresa || b.quantidade - a.quantidade;
        });
    };

    renderEmpty = colSpan => (
        <tr>
            <td className="report-empty" colSpan={colSpan}>
                <i className="far fa-chart-bar" aria-hidden="true" />
                Nenhum registro encontrado para os filtros selecionados.
            </td>
        </tr>
    );

    renderReport = (title, subtitle, icon, count, headers, rows) => (
        <section className="dashboard-panel report-panel">
            <header className="dashboard-panel-header">
                <div className="dashboard-panel-title">
                    <i className={icon} aria-hidden="true" />
                    <div>
                        <h3>{title}</h3>
                        <span>{subtitle}</span>
                    </div>
                </div>
                <span className="report-count">{count} {count === 1 ? 'registro' : 'registros'}</span>
            </header>
            <div className="report-table-wrap">
                <table className="report-table">
                    <thead>
                        <tr>{headers.map(header => <th key={header}>{header}</th>)}</tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </section>
    );

    render() {
        const filtro = this.props.filtro || {};
        const anoAtual = new Date().getFullYear();
        const anos = Array.from({ length: anoAtual - 2022 + 1 }, (_, index) => {
            const ano = String(2022 + index);
            return { id: ano, valor: ano };
        });
        const cooperativas = this.props.listaRelatorioPresencaPorCooperativa || [];
        const empresas = this.props.listaRelatorioPresencaPorEmpresa || [];
        const turmas = this.props.listaRelatorioPresencaPorTurma || [];
        const nuncaParticiparam = this.props.listaRelatorioNuncaParticipam || [];
        const justificativas = this.props.listaRelatorioJustificativas || [];
        const justificativasGerais = this.criarResumoJustificativas(justificativas);
        const justificativasPorEmpresa = this.criarJustificativasPorEmpresa(justificativas);
        const mesSelecionado = meses.find(item => item.id === filtro.mes);
        const periodo = `${mesSelecionado ? mesSelecionado.valor : 'Todos os meses'} de ${filtro.ano || anoAtual}`;
        const empresasFiltradas = (this.props.listaEmpresa || []).filter(item =>
            !filtro.id_cooperativa || String(item.id_cooperativa) === String(filtro.id_cooperativa)
        );
        const turmasFiltradas = (this.props.listaTurma || []).filter(item =>
            (!filtro.id_cooperativa || String(item.id_cooperativa) === String(filtro.id_cooperativa)) &&
            (!filtro.id_empresa || String(item.id_empresa) === String(filtro.id_empresa))
        );
        const obterNomeFiltro = (lista, id, valorPadrao) => {
            const selecionado = (lista || []).find(item => String(item.id) === String(id));
            return selecionado ? selecionado.valor : valorPadrao;
        };
        const tipoSelecionado = obterNomeFiltro(
            [{ id: 'AMBAS', valor: 'Ambas' }, { id: 'INDIVIDUAL', valor: 'Individual' }, { id: 'COLETIVA', valor: 'Coletiva' }],
            filtro.tipo,
            'Ambas'
        );
        const filtrosExcel = [
            ['Tipo de participação', tipoSelecionado],
            ['Ano', String(filtro.ano || anoAtual)],
            ['Mês', mesSelecionado ? mesSelecionado.valor : 'Todos os meses'],
            ['Cooperativa', obterNomeFiltro(this.props.listaCooperativa, filtro.id_cooperativa, 'Todas as cooperativas')],
            ['Empresa', obterNomeFiltro(this.props.listaEmpresa, filtro.id_empresa, 'Todas as empresas')],
            ['Turma', obterNomeFiltro(this.props.listaTurma, filtro.id_turma, 'Todas as turmas')]
        ];
        const percentualExcel = valor => Number(Number(valor || 0).toFixed(2));
        const criarDadosExcel = (colunas, linhas) => ([
            { columns: ['Filtro', 'Valor'], data: filtrosExcel },
            { ySteps: 1, columns: colunas, data: linhas }
        ]);
        const arquivoExcel = `relatorio-participacao-${filtro.ano || anoAtual}-${filtro.mes || 'todos'}`;
        const planilhaCooperativas = criarDadosExcel(
            ['Cooperativa', 'Participação (%)'],
            cooperativas.map(item => [item.nome_cooperativa || '', percentualExcel(item.participacao)])
        );
        const planilhaEmpresas = criarDadosExcel(
            ['Cooperativa', 'Empresa', 'Funcionários', 'Participação (%)'],
            empresas.map(item => [
                item.nome_cooperativa || '',
                item.nome_empresa || '',
                Number(item.quantidade_funcionarios || 0),
                percentualExcel(item.participacao)
            ])
        );
        const planilhaTurmas = criarDadosExcel(
            ['Cooperativa', 'Empresa', 'Turma', 'Funcionários', 'Participação (%)'],
            turmas.map(item => [
                item.nome_cooperativa || '',
                item.nome_empresa || '',
                item.competencia || '',
                Number(item.quantidade_funcionarios || 0),
                percentualExcel(item.participacao)
            ])
        );
        const planilhaNuncaParticiparam = criarDadosExcel(
            ['Cooperativa', 'Empresa', 'Funcionário', 'Matrícula', 'Faltas'],
            nuncaParticiparam.map(item => [
                item.nome_cooperativa || '',
                item.nome_empresa || '',
                item.nome_funcionario || '',
                item.matricula || '',
                Number(item.faltas || 0)
            ])
        );
        const planilhaJustificativasGerais = criarDadosExcel(
            ['Justificativa', 'Ocorrências', 'Percentual (%)'],
            justificativasGerais.map(item => [
                item.nome_justificativa || '',
                Number(item.quantidade || 0),
                percentualExcel(item.participacao)
            ])
        );
        const planilhaJustificativasEmpresa = criarDadosExcel(
            ['Cooperativa', 'Empresa', 'Justificativa', 'Ocorrências', 'Percentual (%)'],
            justificativasPorEmpresa.map(item => [
                item.nome_cooperativa || '',
                item.nome_empresa || '',
                item.nome_justificativa || '',
                Number(item.quantidade || 0),
                percentualExcel(item.participacao)
            ])
        );

        return (
            <Content>
                <main className="seft-dashboard report-page">
                    <section className="dashboard-hero report-hero">
                        <div>
                            <span className="dashboard-eyebrow">Análise de dados</span>
                            <h1>Relatórios de participação</h1>
                            <p>Consulte os resultados por cooperativa, empresa e turma.</p>
                        </div>
                        <div className="report-hero-actions">
                            <div className="dashboard-period">
                                <span>Período selecionado</span>
                                <strong>{periodo}</strong>
                            </div>
                            <ExcelFile
                                filename={arquivoExcel}
                                element={(
                                    <button type="button" className="report-export-button">
                                        <i className="fas fa-file-excel" aria-hidden="true" />
                                        Exportar Excel
                                    </button>
                                )}
                            >
                                <ExcelSheet dataSet={planilhaCooperativas} name="Participação Cooperativa" />
                                <ExcelSheet dataSet={planilhaEmpresas} name="Participação Empresa" />
                                <ExcelSheet dataSet={planilhaTurmas} name="Participação Turma" />
                                <ExcelSheet dataSet={planilhaNuncaParticiparam} name="Nunca participaram" />
                                <ExcelSheet dataSet={planilhaJustificativasGerais} name="Justificativas Gerais" />
                                <ExcelSheet dataSet={planilhaJustificativasEmpresa} name="Justificativas Empresa" />
                            </ExcelFile>
                        </div>
                    </section>

                    <section className="dashboard-filter-card report-filter-card" aria-label="Filtros dos relatórios">
                        <div className="dashboard-filter-title">
                            <i className="fas fa-sliders-h" aria-hidden="true" />
                            Filtros de visualização
                        </div>
                        <Row>
                            <Select
                                options={[{ id: 'AMBAS', valor: 'Ambas' }, { id: 'INDIVIDUAL', valor: 'Individual' }, { id: 'COLETIVA', valor: 'Coletiva' }]}
                                label="Tipo de participação"
                                cols="12 6 4 4"
                                placeholder="Selecione"
                                value={filtro.tipo}
                                onChange={value => this.atualizar({ ...filtro, tipo: value })}
                            />
                            <Select options={anos} label="Ano" cols="12 6 4 4" placeholder="Selecione" value={filtro.ano} onChange={value => this.atualizar({ ...filtro, ano: value })} />
                            <Select options={meses} label="Mês" cols="12 6 4 4" placeholder="Selecione" value={filtro.mes} onChange={value => this.atualizar({ ...filtro, mes: value })} />
                            <Select
                                name="id_cooperativa"
                                options={this.props.listaCooperativa || []}
                                label="Cooperativa"
                                cols="12 6 4 4"
                                placeholder="Todas as cooperativas"
                                value={filtro.id_cooperativa}
                                onChange={value => this.atualizar({ ...filtro, id_cooperativa: value, id_empresa: null, id_turma: null })}
                            />
                            <Select
                                name="id_empresa"
                                options={empresasFiltradas}
                                label="Empresa"
                                cols="12 6 4 4"
                                placeholder="Todas as empresas"
                                value={filtro.id_empresa}
                                onChange={value => this.atualizar({ ...filtro, id_empresa: value, id_turma: null })}
                            />
                            <Select
                                name="id_turma"
                                options={turmasFiltradas}
                                label="Turma"
                                cols="12 6 4 4"
                                placeholder="Todas as turmas"
                                value={filtro.id_turma}
                                onChange={value => this.atualizar({ ...filtro, id_turma: value })}
                            />
                        </Row>
                    </section>

                    <div className="report-summary" aria-label="Resumo dos relatórios">
                        <span><i className="fas fa-handshake" aria-hidden="true" /><strong>{cooperativas.length}</strong> cooperativas</span>
                        <span><i className="fas fa-building" aria-hidden="true" /><strong>{empresas.length}</strong> empresas</span>
                        <span><i className="fas fa-users" aria-hidden="true" /><strong>{turmas.length}</strong> turmas</span>
                    </div>

                    <div className="dashboard-reports report-list">
                        {this.renderReport(
                            'Participação por cooperativa',
                            'Visão consolidada por cooperativa',
                            'fas fa-handshake',
                            cooperativas.length,
                            ['Cooperativa', 'Participação'],
                            cooperativas.length ? cooperativas.map((item, index) => (
                                <tr key={item.id || index} className={this.state.linhaSelecionada === `cooperativa-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`cooperativa-${index}`)}>
                                    <td><strong className="report-primary-cell">{item.nome_cooperativa}</strong></td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(2)
                        )}

                        {this.renderReport(
                            'Participação por empresa',
                            'Detalhamento de empresas e cooperativas',
                            'fas fa-building',
                            empresas.length,
                            ['Cooperativa', 'Empresa', 'Funcionários', 'Participação'],
                            empresas.length ? empresas.map((item, index) => (
                                <tr key={item.id || index} className={this.state.linhaSelecionada === `empresa-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`empresa-${index}`)}>
                                    <td>{item.nome_cooperativa}</td>
                                    <td><strong className="report-primary-cell">{item.nome_empresa}</strong></td>
                                    <td className="report-quantity-cell">
                                        <span>{FormatUtils.formatarValorTela(item.quantidade_funcionarios || 0, 0)}</span>
                                    </td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(4)
                        )}

                        {this.renderReport(
                            'Participação por turma',
                            'Detalhamento de participação das turmas',
                            'fas fa-users',
                            turmas.length,
                            ['Cooperativa', 'Empresa', 'Turma', 'Funcionários', 'Participação'],
                            turmas.length ? turmas.map((item, index) => (
                                <tr key={item.id || index} className={this.state.linhaSelecionada === `turma-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`turma-${index}`)}>
                                    <td>{item.nome_cooperativa}</td>
                                    <td>{item.nome_empresa}</td>
                                    <td><strong className="report-primary-cell">{item.competencia}</strong></td>
                                    <td className="report-quantity-cell">
                                        <span>{FormatUtils.formatarValorTela(item.quantidade_funcionarios || 0, 0)}</span>
                                    </td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(5)
                        )}

                        {this.renderReport(
                            'Nunca participaram',
                            'Funcionários sem nenhuma participação no período selecionado',
                            'fas fa-user-times',
                            nuncaParticiparam.length,
                            [
                                'Cooperativa',
                                'Empresa',
                                'Funcionário',
                                'Faltas'
                            ],
                            nuncaParticiparam.length
                                ? nuncaParticiparam.map((item, index) => (

                                    <tr
                                        key={
                                            item.id_empresa_funcionario ||
                                            index
                                        }
                                        className={
                                            this.state.linhaSelecionada ===
                                            `nunca-participou-${index}`
                                                ? 'is-selected'
                                                : ''
                                        }
                                        onClick={() =>
                                            this.selecionarLinha(
                                                `nunca-participou-${index}`
                                            )
                                        }
                                    >

                                        <td>
                                            {item.nome_cooperativa || '-'}
                                        </td>

                                        <td>
                                            {item.nome_empresa || '-'}
                                        </td>

                                        <td>
                                            <strong className="report-primary-cell">
                                                {item.nome_funcionario || '-'}
                                            </strong>
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <span
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    minWidth: 34,
                                                    padding: '3px 8px',
                                                    borderRadius: 12,
                                                    backgroundColor: '#f8d7da',
                                                    color: '#721c24',
                                                    fontWeight: 700
                                                }}
                                            >
                                                {item.faltas || 0}
                                            </span>
                                        </td>

                                    </tr>

                                ))
                                : this.renderEmpty(4)
                        )}

                        {this.renderReport(
                            'Justificativas gerais',
                            'Percentual de cada justificativa entre todas as ausências do período',
                            'fas fa-clipboard-list',
                            justificativasGerais.length,
                            ['Justificativa', 'Ocorrências', 'Percentual'],
                            justificativasGerais.length ? justificativasGerais.map((item, index) => (
                                <tr key={`justificativa-geral-${item.id_justificativa}`} className={this.state.linhaSelecionada === `justificativa-geral-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`justificativa-geral-${index}`)}>
                                    <td><strong className="report-primary-cell">{item.nome_justificativa}</strong></td>
                                    <td className="report-quantity-cell"><span>{FormatUtils.formatarValorTela(item.quantidade, 0)}</span></td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(3)
                        )}

                        {this.renderReport(
                            'Justificativas por empresa',
                            'Distribuição percentual das justificativas dentro de cada empresa',
                            'fas fa-building',
                            justificativasPorEmpresa.length,
                            ['Cooperativa', 'Empresa', 'Justificativa', 'Ocorrências', 'Percentual'],
                            justificativasPorEmpresa.length ? justificativasPorEmpresa.map((item, index) => (
                                <tr key={`justificativa-empresa-${item.id_empresa}-${item.id_justificativa}`} className={this.state.linhaSelecionada === `justificativa-empresa-${index}` ? 'is-selected' : ''} onClick={() => this.selecionarLinha(`justificativa-empresa-${index}`)}>
                                    <td>{item.nome_cooperativa || '-'}</td>
                                    <td>{item.nome_empresa || '-'}</td>
                                    <td><strong className="report-primary-cell">{item.nome_justificativa}</strong></td>
                                    <td className="report-quantity-cell"><span>{FormatUtils.formatarValorTela(item.quantidade, 0)}</span></td>
                                    <td className="report-participation-cell">{this.renderParticipacao(item.participacao)}</td>
                                </tr>
                            )) : this.renderEmpty(5)
                        )}
                    </div>
                </main>
            </Content>
        );
    }
}

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.relatorio.modoTela,
    filtro: state.relatorio.filtro,
    listaCooperativa: state.relatorio.listaCooperativa,
    listaEmpresa: state.relatorio.listaEmpresa,
    listaTurma: state.relatorio.listaTurma,
    listaRelatorioPresencaPorCooperativa: state.relatorio.listaRelatorioPresencaPorCooperativa,
    listaRelatorioPresencaPorEmpresa: state.relatorio.listaRelatorioPresencaPorEmpresa,
    listaRelatorioPresencaPorTurma: state.relatorio.listaRelatorioPresencaPorTurma,
    listaRelatorioNuncaParticipam: state.relatorio.listaRelatorioNuncaParticipam,
    listaRelatorioJustificativas: state.relatorio.listaRelatorioJustificativas
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    setFiltro,
    getListaCooperativa,
    getListaEmpresa,
    getListaTurma,
    getListaRelatorioPresencaPorCooperativa,
    getListaRelatorioPresencaPorEmpresa,
    getListaRelatorioPresencaPorTurma,
    getListaRelatorioNuncaParticiparam,
    getListaRelatorioJustificativas
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Relatorio);
